export default __webpack_public_path__ + "static/Bubble_icon-985bd9b72a22715f2d9a36c25ccfb5e1.png";